import { createFileRoute, notFound } from "@tanstack/react-router";
import { getUILanguage, useAlbertineTranslation } from "albertine-shared-web";
import { PolicyDocument } from "../-components/PolicyDocument";
import { policiesConfigs } from "../-config/policies";

export const Route = createFileRoute("/privacy-policy/")({
    component: PrivacyPolicyRoute,
    beforeLoad: () => {
        document.documentElement.style.setProperty(
            "--color-body-top",
            "var(--color-background-profile-secondary)",
        );
        document.documentElement.style.setProperty(
            "--color-body-bottom",
            "var(--color-background-profile-secondary)",
        );
    },
    head: ({ match }) => ({
        meta: [
            {
                title: `Privacy policy - ${match.search.tenant} ${match.search.locale}`,
            },
        ],
    }),
    onError: () => {
        throw notFound();
    },
});

function PrivacyPolicyRoute() {
    const { tenant } = Route.useSearch();
    const t = useAlbertineTranslation();
    const html = policiesConfigs[tenant].privacyPolicy[getUILanguage().lang];

    return <PolicyDocument title={t("profile__privacy-policy")} html={html} />;
}
